import { UPDATE_PROFILE } from '@storeOld/actions'
import { avatarDeleteRequest } from '@storeOld/reducers/auth'
import { useDispatch } from 'react-redux'

// todo: remove API usage after nest backend storage realization
import API from '@/api'
import { useAuth } from '@/hooks'

export const useUserAvatar = () => {
  const user = useAuth()
  const dispatch = useDispatch()

  const onUpload = (files: FileList | null) => {
    if (!files || files.length === 0) {
      return
    }

    const formData = new FormData()
    formData.append('file', files[0])

    API.Auth.avatar(formData)
      .then((payload) => {
        dispatch({ type: UPDATE_PROFILE, payload })
      })
      .catch((e) => console.error(e))
  }

  const onDelete = () => {
    dispatch(
      // @ts-expect-error
      avatarDeleteRequest(() => {
        API.Auth.avatar(null)
          .then(() =>
            dispatch({ type: UPDATE_PROFILE, payload: { avatar: null } })
          )
          .catch((e) => console.error(e))
      })
    )
  }

  return { url: user.avatar, onUpload, onDelete }
}
